import { apiLegacy } from "@/lib/axios"
import { useQuery } from "react-query"
import { useAppConfigStore } from "@/store/app"
import { get } from "lodash";

export const useGetAppConfig = () => {
  const appConfigStore = useAppConfigStore()
  return useQuery({
    queryKey:['app-config'],
    queryFn: () => apiLegacy.get('app-config/get'),
    onSuccess:({data}) => {
      appConfigStore.setPaidFeature(get(data, 'result.onlinelearning_paid_feature', 'false'));
    }
  })
}